<template>
	<base-block
		title="Offerings"
		header-bg
	>
		<div
			ref="offeringTable"
		/>
	</base-block>
</template>
